import { Injectable, signal } from '@angular/core';
import { Module } from '~shared/models/module.model';

@Injectable({ providedIn: 'root' })
export class ModulesService {
  modules = signal<Module[]>([]);

  getModules() {
    return this.modules();
  }

  setModules(modules: Module[]) {
    this.modules.set([]);
    this.modules.set(modules);
  }
}
